import { lazy } from "react";

const Document = lazy(() => import("./Document"));
const ImportDoc = lazy(() => import("./ImportDoc"));

const DocumentRoutes = [
  {
    path: "/Document",
    element: <Document />,
  },
  {
    path: "/Importation-doc",
    element: <ImportDoc />,
  },
 
];

export default DocumentRoutes;
